import { isNullOrEmptySpace, NO_VALUE_DISPLAY } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvNumberCellTransformer = (): {
  getNumberValue: CsvCellTransformerFn;
} => {
  const getNumberValue = ({ value }: ICsvColumnTransformer): string => {
    return !isNullOrEmptySpace(value) ? String(value) : NO_VALUE_DISPLAY;
  };

  return { getNumberValue };
};
